import * as CONSTANTS from './constants';

export const getInitialState = () => {
  return {
    flavour: '',
    payment: '',
    trn: '',
    vertical_txn_id: '',
    pay_txn_id: '',
    pay_session_id: '',
    pay_status: '',
    request_id: '',
    pg: '',
    format: '',
    data: {},
    status: '',
    isError: false,
    feedbackTaken: null
  }
}

const Thankyou = (state = getInitialState(), action) => {
  const { type, actionData } = action;

  switch (type) {
    case CONSTANTS.THANKYOUPAGE_URL_PARAMS:
      return Object.assign({}, {
        ...state,
        flavour: actionData.flavour,
        payment: actionData.payment,
        trn: actionData.trn,
        vertical_txn_id: actionData.vertical_txn_id,
        pay_txn_id: actionData.pay_txn_id,
        pay_session_id: actionData.pay_session_id,
        pay_status: actionData.pay_status,
        request_id: actionData.request_id,
        pg: actionData.pg,
        format: actionData.format

      })
    case CONSTANTS.THANKYOUPAGE_INFO:
      return Object.assign({}, {
        ...state,
        data: actionData.data,
        payment: actionData.data.is_failed ? 'failure' : 'success'
      })
    case CONSTANTS.UPDATE_BOOKING_STATUS:
      return Object.assign({}, {
        ...state,
        status: actionData.status
      })
    case CONSTANTS.SET_THANKYOU_ERROR:
      return Object.assign({}, {
        ...state,
        isError: actionData.error
      })
    case CONSTANTS.SET_FEEDBACK_STATUS:
      return Object.assign({}, {
        ...state,
        feedbackTaken: actionData.status
      })
    default:
      return state;
  }
}

export default Thankyou;
